<template>
  <div
    class="d-flex flex-column gr-2"
    data-qa="payment_terms"
  >
    <template v-if="appointmentDataStore.isAnyTelemed">
      <template v-if="calendarDataStore.isCalendarDateSelected">
        <div class="d-flex align-center text-h6 text--text">
          {{ t('К оплате', options) }}
          <span
            data-qa="payment_terms_telemed_price"
            class="ml-auto"
          >
            {{ doctorDataStore.workplacePriceText }}
          </span>
        </div>
      </template>
    </template>
    <template v-else-if="doctorDataStore.selectedWorkplace.isFreeWithTreatment">
      <div class="text-h6 text--text">
        {{ t('Условия оплаты', options) }}
      </div>
      <div
        data-qa="payment_terms_free_appointment_with_treatment"
        class="d-flex flex-column gr-4"
      >
        <div class="d-flex align-center">
          <div class="text-body-1 text-secondary--text">
            {{ t('Обычная цена', options) }}
          </div>
          <div
            class="text-body-1 text--text text-decoration-line-through ml-auto"
            data-qa="payment_terms_full_price"
          >
            {{ doctorDataStore.workplacePriceText }}
          </div>
        </div>

        <div class="d-flex align-center gc-2">
          <div class="text-body-1 text-secondary--text">
            {{ t('Акционная цена', options) }}
          </div>
          <span class="ui-icon-tag-discount text-success--text" />
          <div
            class="text-body-1 text-success--text ml-auto"
            data-qa="payment_terms_promotional_price"
          >
            0 {{ currencySymbol }}
          </div>
        </div>

        <div class="text-body-2 text--text">
          <!-- eslint-disable max-len -->
          {{ t('Действует при условии дальнейшего лечения в клинике. При отказе от лечения оплачивается обычная цена консультации. Подробности уточняйте в клинике.', options) }}
        </div>
      </div>

      <div class="d-flex align-center text-subtitle-1 text--text">
        {{ t('Оплата в клинике', options) }}
        <span
          data-qa="payment_terms_lpu_price"
          class="ml-auto"
        >
          0 {{ currencySymbol }}
        </span>
      </div>
    </template>
    <div
      v-else
      class="d-flex align-center text-h6 text--text"
    >
      {{ t('Оплата в клинике', options) }}
      <span
        data-qa="payment_terms_lpu_price"
        class="ml-auto"
      >
        {{ doctorDataStore.workplacePriceText }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { useDoctorDataStore } from 'www/vue_components/common/AppointmentPage/stores'
import useAppointmentDataStore from 'www/vue_components/common/AppointmentPage/stores/useAppointmentDataStore'
import useCalendarDataStore from 'www/vue_components/common/AppointmentPage/stores/useCalendarDataStore'

const currencySymbol = window.CURRENCY_DATA.symbol
const appointmentDataStore = useAppointmentDataStore()
const calendarDataStore = useCalendarDataStore()
const doctorDataStore = useDoctorDataStore()

const { t, language } = I18NextVue
const options = { ns: language }
</script>
